<template>
  <section v-if="name === 'slider'||name ==='banner'" class="section">
    <div class="section-header with-border">
      设置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <template v-if="type=='wxapp'">
          <el-form-item label="标题">
            <el-input v-model="base.title"></el-input>
          </el-form-item>
          <el-form-item label="副标题">
            <el-input v-model="base.subtitle"></el-input>
          </el-form-item>
          <el-form-item label="组件间距">
            <el-switch
              v-model="base.padded"
              active-color="#27cc6a"
              inactive-color="#efefef">
            </el-switch>
          </el-form-item>
          <el-form-item label="圆角图片">
            <el-switch
              v-model="config.rounded"
              active-color="#27cc6a"
              inactive-color="#efefef">
            </el-switch>
          </el-form-item>
          <el-form-item label="图片间隔">
            <el-switch
              v-model="config.padded"
              active-color="#27cc6a"
              inactive-color="#efefef">
            </el-switch>
          </el-form-item>
          <el-form-item label="指示点样式">
            <el-switch
              v-model="config.dot"
              active-text="点"
              inactive-text="数字"
              active-color="#27cc6a"
              inactive-color="#ffa100">
            </el-switch>
          </el-form-item>
          <el-form-item label="指示点覆盖">
            <el-switch
              v-model="config.dotCover"
              active-color="#27cc6a"
              inactive-color="#efefef">
            </el-switch>
          </el-form-item>
          <el-form-item label="指示点位置">
            <el-radio-group v-model="config.dotLocation">
              <el-radio label="left">居左</el-radio>
              <el-radio label="center">居中</el-radio>
              <el-radio label="right">居右</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="指示点形状">
            <el-radio-group v-model="config.shape">
              <el-radio label="circle">圆形</el-radio>
              <el-radio label="rectangle">长方型</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="指示点颜色">
            <el-radio-group v-model="config.dotColor">
              <el-radio label="dark">深色</el-radio>
              <el-radio label="light">亮色</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="轮播项间距">
            <el-switch
              v-model="config.padded"
              active-color="#27cc6a"
              inactive-color="#efefef">
            </el-switch>
          </el-form-item>
          <el-form-item label="开启图片描述">
            <el-switch
              v-model="config.content"
              active-color="#27cc6a"
              inactive-color="#efefef">
            </el-switch>
          </el-form-item>
        </template>

        <el-form-item label="轮播项">
          <draggable v-model="data" :options="dragIssuesOptions" @start="onStart" @end="onEnd">
          <div class="setting-item slider" v-for="(item, index) in data" :key="index">
            <div class="setting-remove" @click="removeItem(index)"><i class="iconfont icon-trash-alt"></i></div>
            <template v-if="type==='wxapp'">
              <img v-if="item.imgUrl" :src="wximageurl + item.imgUrl" class="banner-uploader" @click="handleImgChange(index)"/>
              <div class="banner-uploader" v-else @click="handleImgChange(index)">
                <i class="iconfont icon-camera"></i>
                上传图片
              </div>
              <div class="uploader-setting">
                <el-input v-if="config.content" type="textarea" placeholder="文字描述" v-model="item.content"></el-input>
                <div class="goods-select" @click="handleGoodsChange(index)">
                  <div class="link-content" v-if="item.id">
                    <template v-if="item.linkPage === 'goods'">商品：</template>
                    <template v-if="item.linkPage === 'category'">分类：</template>
                    <template v-if="item.linkPage === 'article'">文章：</template>
                    <template v-if="item.linkPage === 'planting'">软文：</template>
                    <template v-if="item.linkPage === 'link'">页面：</template>
                    <template v-if="item.linkPage === 'marketing'">营销：</template>
                    {{item.title}}
                  </div>
                  <div v-else class="content-center"><i class="iconfont icon-link" @click="handleGoodsChange(index)"></i>设置路径</div>
                </div>
              </div>
            </template>
            <template v-if="type==='pc'">
              <img v-if="item.url" :src="item.url" class="banner-uploader" @click="handleImgChange(index)"/>
              <div v-else class="banner-uploader"  @click="handleImgChange(index)">
                <i class="iconfont icon-camera"></i>
                上传图片
              </div>
              <div class="uploader-setting">
                <el-input v-if="config.content" type="textarea" placeholder="文字描述" v-model="item.content"></el-input>
                <div class="goods-select" @click="handleGoodsChange(index)">
                  <div class="link-content" v-if="item.goodsId">
                    商品：{{item.title}}
                  </div>
                  <div v-else class="content-center"><i class="iconfont icon-link" @click="handleGoodsChange(index)"></i>设置路径</div>
                </div>
              </div>
          </template>
          </div>
          </draggable>
        </el-form-item>
      </el-form>
      <div class="content-center">
        <div class="frm-tips">只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）</div>
        <el-button  class="iconfont icon-plus-circle banner-button-uploader" @click="addItem"> 添加轮播图</el-button>
      </div>
    </div>
  </section>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable
    },
    props: {
      res: {
        type: Object,
        default: {}
      },
      type: {
        type: String, // pc 传'pc'即可
        default: 'wxapp'
      }
    },
    watch: {
      res (value) {
        if (value) {
          this.setData(value)
        }
      }
    },
    data () {
      return {
        name: '',
        base: {},
        config: {},
        data: [],
        dragIssuesOptions: {
          group: {
            name: 'easyview'
          },
          animation: 300,
          forceFallback: true,
          scroll: true,
          sort: true,
        },
      }
    },
    methods: {
      setData (val) {
        this.name = val.name
        this.base = val.base
        this.config = val.config
        this.data = val.data
      },
      // 拖拽绑定事件
      onStart (evt) {
        // 记录拖拽前的数据
        // this.saveInit = JSON.stringify(this.data[evt.oldIndex])
        console.log(this.data)
      },
      onEnd (evt) {
        // 将拖拽前的数据插入到拖拽后的位置
        // this.data.splice(evt.oldIndex, 0, JSON.parse(this.saveInit))
        // 删除拖拽前的数据
        // this.data.splice(evt.oldIndex, 1)
        console.log(this.data)
        this.$emit('bindSort', this.data)
      },
      removeItem (index) {
        this.data.splice(index, 1)
      },
      addItem () {
        if (!this.data) {
          this.data = []
        }
        let item = {
          imgUrl: '',
          linkPage: '',
          content: '',
          id: ''
        }
        // 去掉轮播图限制
        // if (this.data.length > 4) {
        //   this.$message({
        //     message: '轮播图最多添加5个图片',
        //     type: 'error',
        //     duration: 5 * 1000
        //   })
        // } else {
        //   this.data.push(item)
        // }
        this.data.push(item)
      },
      handleImgChange (index) {
        this.$emit('bindImgs', index)
      },
      handleGoodsChange (index) {
        this.$emit('bindLinks', index)
      }
    },
    mounted () {
      this.setData(this.res)
    }
  }
</script>



// WEBPACK FOOTER //
// slider.vue?dcedc136